import { Address } from "../../types/interfaces";

const AddressDisplay = ({ address }: { address?: Address | null }) => {
  if (!address) {
    return "Adresse non renseignée";
  }

  return (
    <>
      {address.streetNumber}, {address.streetName}
      {address.details && <>, {address.details}</>}
      <br />
      {address.postcode}, {address.city}
    </>
  );
};

export default AddressDisplay;
